<template>
  <div
    class="login-bg"
    v-bind:style="{ backgroundImage: 'url(' + image + ')' }"
  >
    <v-main class="mt-4 pt-4">
      <v-container fluid fill-height grid-list-md>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12 signup-card pa-4">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="text-center align-center">
                      <img
                        src="@/assets/img/volk-logo.png"
                        width="200"
                      ></img>
                    </div>

                    <br />
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="firstName"
                            label="First Name"
                            :rules="[(v) => !!v || 'First Name is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="lastName"
                            label="Last Name"
                            :rules="[(v) => !!v || 'Last Name is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="Email"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="password"
                            :rules="passwordRules"
                            label="Create Password"
                            required
                            type="password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-select
                            v-model="role"
                            :items="['Foreman', 'Driver', 'Mechanic']"
                            required
                            :rules="[(v) => !!v || 'Role is required']"
                            label="Select your role"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="phone"
                            v-mask="'(###) ###-####'"
                            label="Contact Phone number"
                            :rules="[(v) => !!v || 'Contact number required.']"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <br />
                      <div class="grey--text">
                        By creating an account, you are agreeing to our
                        <a href>Terms of Service</a> and
                        <a href>Privacy Policy</a>
                      </div>
                      <br />
                      <v-btn
                        :disabled="!valid"
                        @click="submit"
                        block
                        color="primary"
                        large
                        >Create Account</v-btn
                      >
                      <br />
                      <p class="text-xs-center">
                        Already registered?
                        <a href="/login">Sign In</a>.
                      </p>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-snackbar v-model="snackbar" color="primary"
          >A confirmation email has been sent. Please click on the link to
          confirm your email.</v-snackbar
        >
      </v-container>
    </v-main>
  </div>
</template>

<script>
import image from "@/assets/nyc-bg.jpg";
import firebase from "firebase/app";
import { mask } from "vue-the-mask";
export default {
  name: "login",
  directives: {
    mask,
  },
  data() {
    return {
      image: image,
      firstName: "",
      lastName: "",
      valid: true,
      username: "",
      email: "",
      phone: "",
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      password: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length > 5) || "password must be more than 5 characters",
      ],
      snackbar: false,
      role: "",
    };
  },
  async created() {
    const user = await firebase.auth().currentUser;
    if (user) {
      await firebase.auth().signOut();
    }
  },
  methods: {
    async submit(e) {
      this.email = this.email.trim();
      this.email = this.email.toLowerCase();
      if (this.$refs.form.validate()) {
        try {
          let authData = await firebase
            .auth()
            .createUserWithEmailAndPassword(this.email, this.password);
          if (authData.user) {
            const userData = {
              firstName: this.firstName,
              lastName: this.lastName,
              role: this.role,
              phone: this.phone,
              email: this.email,
              uid: authData.user.uid,
              createDate: firebase.firestore.FieldValue.serverTimestamp(),
            };
            firebase
              .firestore()
              .collection("users")
              .doc(authData.user.uid)
              .set(userData);
            this.$store.commit("cacheUser", userData);
            this.$router.push("/tools/order");
          }
        } catch (error) {
          console.log(error);
          alert(error.message);
        }
      }
      e.preventDefault();
    },
  },
};
</script>

<style scoped>
.login-bg {
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
